import { Link } from "react-router-dom";
import { useApps, useDeleteApp } from "../../hooks/useApps";
import { useAuthStore } from "../../store/auth.store";

function TrashIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  );
}

function EditIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  );
}

function AppIcon({ name, logoUrl, iconUrl }: { name: string; logoUrl: string | null; iconUrl: string | null }) {
  const src = logoUrl || iconUrl;
  if (src) {
    return (
      <img
        src={src}
        alt=""
        style={{ width: 28, height: 28, borderRadius: 6, objectFit: "contain", display: "block" }}
        onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
      />
    );
  }
  return (
    <div style={{
      width: 28, height: 28, borderRadius: 6,
      background: "var(--bg-elev-2)",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontWeight: 600, fontSize: 12, color: "var(--text-muted)",
      flexShrink: 0,
    }}>
      {name.charAt(0).toUpperCase()}
    </div>
  );
}

export function AppList() {
  const { data: apps, isLoading } = useApps();
  const deleteApp = useDeleteApp();
  const isAdmin = useAuthStore((s) => s.user?.isPanelAdmin === true);

  async function handleDelete(id: string, name: string) {
    if (!confirm(`Delete app "${name}"? This cannot be undone.`)) return;
    await deleteApp.mutateAsync(id);
  }

  return (
    <>
      <div className="page-header">
        <h2>Apps</h2>
        {isAdmin && (
          <Link to="/apps/new">
            <button className="primary">Register app</button>
          </Link>
        )}
      </div>

      {isLoading && <p className="muted">Loading…</p>}

      {apps && (
        <div className="card table-scroll" style={{ padding: 0 }}>
          <table style={{ tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 44 }} />
              <col style={{ width: 200 }} />
              <col />
              <col />
              <col style={{ width: 72 }} />
            </colgroup>
            <thead>
              <tr>
                <th style={{ paddingRight: 0 }}></th>
                <th>Name</th>
                <th>Description</th>
                <th>URL</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {[...apps].sort((a, b) => a.name.localeCompare(b.name)).map((app) => (
                <tr key={app.id}>
                  <td style={{ paddingRight: 0 }}>
                    <AppIcon name={app.name} logoUrl={app.logoUrl} iconUrl={app.iconUrl} />
                  </td>
                  <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    <Link to={`/apps/${app.id}`}>{app.name}</Link>
                  </td>
                  <td className="muted" style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontSize: 13,
                  }}>
                    {app.description ?? <span style={{ opacity: 0.4 }}>—</span>}
                  </td>
                  <td className="muted" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13 }}>
                    {app.url}
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                      {isAdmin && (
                        <>
                          <Link to={`/apps/${app.id}`}>
                            <button title="Edit" style={{ padding: "6px 8px", lineHeight: 0 }}>
                              <EditIcon />
                            </button>
                          </Link>
                          <button
                            onClick={() => handleDelete(app.id, app.name)}
                            className="danger"
                            title="Delete"
                            style={{ padding: "6px 8px", lineHeight: 0 }}
                          >
                            <TrashIcon />
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
